const mutations = {
  changeLoginStatus (state, payload) {
    state.user.isLogin = payload
  },
  tokenChange (state, payload) {
    state.user.token = payload
  },
  tokenRefreshTime (state, payload) {
    state.user.tokenRefreshTime = payload
  },
  changeShiftStatus (state, payload) {
    state.shift.isStarted = payload
  },
  changeWorkdayStatus (state, payload) {
    state.workday.isStarted = payload.isStarted
    if (payload.isStarted) {
      state.workday.id = payload.workdayId
    } else {
      state.workday.id = null
    }
  },
  addShiftEvent (state, payload) {
    state.shift.events.unshift(payload)
  },
  setShiftId (state, payload) {
    state.shift.id = payload
  },
  addImage (state, imageId) {
    state.jobs.images.push(imageId)
  },
  resetStateImages (state) {
    state.jobs.images = []
  },
  addSignature (state, signatureId) {
    state.jobs.signatures.push(signatureId)
  },
  resetStateSignatures (state) {
    state.jobs.signatures = []
  },
  addDriverJobs (state, payload) {
    // Saving finished status
    let jobStatusesArray = []
    if (state.driverJobs.length > 0) {
      state.driverJobs.forEach(function (item) {
        let statusJob = {
          id: item.id,
          isFinished: item.isFinished
        }
        jobStatusesArray.push(statusJob)
      })
    }
    state.driverJobs = []
    for (let key in payload) {
      let job = {
        'id': payload[key].jobId || '',
        'isFinished': checkJobStatus(key) || '',
        'address': payload[key].address || '',
        'city': payload[key].city || '',
        'country': payload[key].country || '',
        'contact': payload[key].contact || '',
        'frequencySummer': payload[key].frequencySummer || '',
        'frequencyWinter': payload[key].frequencyWinter || '',
        'locationId': payload[key].locationId || '',
        'locationName': payload[key].locationName || '',
        'locationType': payload[key].locationType || '',
        'phone': payload[key].phone || '',
        'routeSheetId': payload[key].routeSheetId || '',
        'stopNumber': payload[key].stopNumber || '',
        'note': payload[key].note || '',
        'stands': setStands(payload[key].stands)
      }
      state.driverJobs.push(job)
    }
    function checkJobStatus (key) {
      let jobStatus = jobStatusesArray.find(jobStatus => jobStatus.id === +key)
      return jobStatus || false
    }
    function setStands (standsData) {
      let stands = []
      standsData.forEach((stand) => {
        let singleStand = {
          'notes': stand.notes || null,
          'pockets': stand.pockets || null,
          'sectorId': stand.sectorId || null,
          'sectorName': stand.sectorName || null,
          'headerName': stand.headerName || null,
          'standID': stand.standID || null,
          'type': stand.type || null,
          'class': stand.class || null,
          'deliveryId': stand.deliveryId || null,
          'product': stand.product || null,
          'quantity': stand.quantity || null,
          'headerCapableDrivers': typeof stand.headerCapableDrivers === 'boolean' ? stand.headerCapableDrivers : null,
          'canBeRelocated': stand.canBeRelocated || null,
          'outletWithin6Feet': typeof stand.outletWithin6Feet === 'boolean' ? stand.outletWithin6Feet : null
        }
        stands.push(singleStand)
      })
      return stands
    }
  },
  startJob (state, payload) {
    state.activeJob.id = payload.id
    state.activeJob.isStarted = true
    state.activeJob.startTime = payload.startTime
  },
  endJob (state, endTime) {
    state.activeJob.isStarted = false
    state.activeJob.endTime = endTime
  },
  deleteDriverJobs (state) {
    state.driverJobs = []
  },
  setCurrentStand (state, standId) {
    state.currentStand = standId
  },
  setCurrentJob (state, jobId) {
    state.currentJob = jobId
  },
  updateUserName (state, name) {
    state.user.name = name
  },
  updateRouteSheetName (state, name) {
    state.currentSheetName = name
  },
  updateTestFunctions (state, testFunctions) {
    state.driver.testFunctions = testFunctions
  },
  createStands (state, data) {
    state.stands.push(data)
  },
  skipStand (state, dataobj) {
    let stands = state.stands
    stands.find(stand => {
      if (stand.standId === dataobj.standId && stand.jobId === dataobj.jobId) {
        stand.isSkipped = true
      }
    })
  },
  setAciveStand (state, params) {
    let Id = params[0]
    let jobId = params[1]
    let stands = state.stands
    stands.forEach(function (stand) {
      if (stand.standId === Id && stand.jobId === jobId) {
        stand.isActive = true
        stand.isCompleted = false
      }
    })
  },
  completeJobAction (state, data) {
    let completeJobAction = {
      standId: data.activeStandId,
      jobId: data.activeJobId,
      jobActionType: data.jobActionType
    }
    state.completedJobActions.push(completeJobAction)
  },
  endJobActions (state, activeStand) {
    let stands = state.stands
    stands.forEach(function (stand) {
      if (stand.standId === activeStand.standId &&
        stand.jobId === activeStand.jobId) {
        stand.isActive = false
        stand.isCompleted = true
      }
    })
  },
  finishJob (state, jobId) {
    let jobs = state.driverJobs
    jobs.find(function (job) {
      if (job.id === jobId) job.isFinished = true
    })
  },
  deleteJob (state, jobId) {
    let jobs = state.driverJobs
    let index = jobs.findIndex(job => job.id === jobId)
    state.driverJobs.splice(index, 1)
  },
  saveLocation (state, location) {
    state.positionArray = []

    // let locationObject = {
    //   lat: location.lat,
    //   lng: location.lng,
    //   time: location.time
    // }
    // state.positionArray.push(locationObject)
  },
  saveCustomForms (state, forms) {
    state.customForms = forms
  },
  setCurrentCustomForm (state, formName) {
    state.currentCustomForm = formName
  },
  reloadCustomForm (state) {
    state.currentCustomForm = ''
  },
  stateUpdate (state, newState) {
    if (newState) {
      state = Object.assign(state, newState)
    }
  },
  createJobFromTabled (state, jobObj) {
    let createdJob = state.createdCustomJob
    createdJob.jobId = jobObj.jobId || null
    createdJob.locationId = jobObj.locationId || null
    createdJob.nameAdress = jobObj.nameAdress || null
    createdJob.jobActionType = jobObj.jobActionType || null
  },
  resetJobCreatedFromTabled (state) {
    let createdJob = state.createdCustomJob
    createdJob.jobId = createdJob.locationId = createdJob.nameAdress = createdJob.jobActionType = null
  },
  updateDriverInfo (state, dataObj) {
    let driverInfo = state.driver
    Object.keys(dataObj).forEach((key, index) => {
      if (driverInfo.hasOwnProperty(key)) {
        driverInfo[key] = dataObj[key] || ''
      }
    })
  }
}
export default mutations
